import React, { useState } from 'react';
import './Gastos.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import GastosData from '../../Components/Admin/GastosData/GastosData';
import CategoriasGastosData from '../../Components/Admin/CategoriasGastosData/CategoriasGastosData';

export default function Gastos() {
    const [tabActiva, setTabActiva] = useState('gastos');

    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection gastosContainer'>
                <HeaderDash />
                <div className='gastos-container-wrapper'>
                    <div className='gastosTabs'>
                        <button
                            className={tabActiva === 'gastos' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('gastos')}
                        >
                            Registro de Gastos
                        </button>
                        <button
                            className={tabActiva === 'categorias' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('categorias')}
                        >
                            Categorías de Gastos
                        </button>
                    </div>

                    <div className='gastosContent'>
                        {tabActiva === 'gastos' && <GastosData />}
                        {tabActiva === 'categorias' && <CategoriasGastosData />}
                    </div>
                </div>
            </section>
        </div>
    );
}






